export default {
	Admin: "b8523895-dbe8-11e9-bfb2-0a8acc259594",
	AWGMember: "e04dc3a9-dbe8-11e9-bfb2-0a8acc259594",
	AWGMemberCTC: "87dbeb69-a930-11eb-bdc7-0a14b8f4c1fd",
	AWGMemberACC: "8fd58f64-a930-11eb-bdc7-0a14b8f4c1fd",
	Enhanced: "e6d12e47-dbe8-11e9-bfb2-0a8acc259594",
	Standard: "e9874e89-dbe8-11e9-bfb2-0a8acc259594",
	CountryRespondent: "f4a3f3aa-dbe8-11e9-bfb2-0a8acc259594",
	CountryViewer: "f9f3b143-dbe8-11e9-bfb2-0a8acc259594",
	FreeAccess: "d2196a6c-e3c0-11e9-bfb2-0a8acc259594",
	CFTAccess: "fe72c186-1b99-11ea-bfb2-0a8acc259594",
	AnnotationAccess: "fe72c405-1b99-11ea-bfb2-0a8acc259594",
	ScoringAccess: "fe72c47f-1b99-11ea-bfb2-0a8acc259594",
	CFTPackage: "d37f4991-1798-11ea-bfb2-0a8acc259594",
	ACCPresaleAccess: "783ef5f4-867f-11eb-bdc7-0a14b8f4c1fd",
	ACCFullAccess: "eb68cbac-7d1e-11eb-969d-0a8acc259594"
}
